<template>
  <div class="animated fadeIn equipmentList bgV2">
    <b-row>
      <b-col md="12">
        <div class="boxShadow heig-frame mt-16 border-top-right-radius">
          <div class="padding-13 padding-scroll pt-15 heig-frame-child">
            <b-row class="content">
              <b-col md="3">
                <div class="control pull-left">
                  <div class="list innerControl">
                    <span class="search" @click="refresh" v-b-tooltip.hover title="Refresh">
                      <img src="img/reLoad.png" alt="reload" />
                    </span>
                    <span class="search"v-b-tooltip.hover title="Create" @click="redirectCreate">
                      <img src="img/blankIcon.png" alt="blank" />
                    </span>
                    <span v-if="selected.length > 0" class="search" v-b-tooltip.hover title="Delete" @click="$bvModal.show('modal-Remove')">
                      <img src="img/deleteIcon.png" alt="delete" />
                    </span>
                  </div>
                </div>
                <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" ref="modal-Remove">
                  <div class="center">Are you sure you want to<br/>delete <strong>This Item</strong>?
                  </div>
                  <b-button-group class="btn-group">
                    <b-button class="custom-btn" @click="$bvModal.hide('modal-Remove')">No
                    </b-button>
                    <b-button class="custom-btn" @click="deleteData" :disabled="isAction">Yes</b-button>
                  </b-button-group>
                </b-modal>
              </b-col>
              <b-col md="9">
                <div class="control">
                  <gofix-button class="pull-left" label="RAISE A CASE" @click="openModalRaiseACase" v-show="selected.length > 0" outline></gofix-button>
                  <b-modal :no-close-on-backdrop="true" id="modal-RaiseACase" title="Raise A Case" hide-footer :centered="true" ref="modal-RaiseACase" :no-close-on-esc="true" ::no-close-on-backdrop="true">
                    <b-form class="formV2">
                      <b-row>
                        <b-col md="12">
                          <gofix-form-dropdown
                                  label="Client Contract"
                                  vLabel="contract_name"
                                  :filterable="false"
                                  @search="searchContract"
                                  v-model="hardcodeData.contract"
                                  :options="clientContract">
                          </gofix-form-dropdown>
                        </b-col>
                        <b-col md="12">
                          <gofix-form-dropdown
                                  label="Assign To"
                                  vLabel="name"
                                  :filterable="false"
                                  @search="searchContract"
                                  v-model="hardcodeData.assign"
                                  :options="users">
                          </gofix-form-dropdown>
                        </b-col>
                        <b-col md="12" class='pd-0'>
                          <div class="content title">
                            <label>Similar Case</label>
                          </div>
                        </b-col>
                      </b-row>
                      <ul class="list">
                        <li>
                          <b-row>
                            <b-col md="6">
                              <div class="content mt-20">
                                <label class="mb-0">Location</label>
                                <div>Marina Barrage >> DPS Building >> Maintenance Office >> Corridor</div>
                              </div>
                            </b-col>
                            <b-col md="3">
                              <div class="content mt-20">
                                <label class="mb-0">Fault Type</label>
                                <div>Water Leaking</div>
                              </div>
                            </b-col>
                            <b-col md="3">
                              <gofix-button label="SIMILAR CASE" outline unsetMinWith whiteSpace></gofix-button>
                            </b-col>
                          </b-row>
                        </li>
                        <li>
                          <b-row>
                            <b-col md="6">
                              <div class="content mt-20">
                                <label class="mb-0">Location</label>
                                <div>Marina Barrage >> DPS Building >> Maintenance Office >> Corridor</div>
                              </div>
                            </b-col>
                            <b-col md="3">
                              <div class="content mt-20">
                                <label class="mb-0">Fault Type</label>
                                <div>Others</div>
                              </div>
                            </b-col>
                            <b-col md="3">
                              <gofix-button label="SIMILAR CASE" outline unsetMinWith whiteSpace></gofix-button>
                            </b-col>
                          </b-row>
                        </li>
                      </ul>

                      <b-button-group class="d-block text-right">
                        <gofix-button label="SUBMIT" :loading="isAction" noBorder></gofix-button>
                      </b-button-group>
                    </b-form>
                  </b-modal>
                  <Pagination :Items="this.Items" v-model="pages"></Pagination>
                  <div class="list innerControl ml-2">
                    <span class="filter" v-on:click="filterActive" v-bind:class="[filterActive, activeClass ? 'active' : '']" >
                      <div class="tooltip">Filter</div>
                      <svg width="21" height="13" viewBox="0 0 21 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                        d="M8.30512 13H12.7496V10.8333H8.30512V13ZM0.527344 0V2.16667H20.5273V0H0.527344ZM3.86068 7.58333H17.194V5.41667H3.86068V7.58333Z"
                        fill="#999999"
                        />
                      </svg>
                    </span>
                    <span class="search">
                      <div class="tooltip">Setting</div>
                      <b-dropdown class="btn btnConfig" right>
                        <b-dropdown-item href="#">Import</b-dropdown-item>
                        <b-dropdown-item href="#">Export</b-dropdown-item>
                        <ColumnSetting v-model="columnActive" :nameTable="this.nameTable"></ColumnSetting>
                      </b-dropdown>
                    </span>
                  </div>
                </div>
              </b-col>
              <b-col md="12">
                <b-table :fields="columnActive.show" @row-clicked="" :items="Items.data" class="table-filter" v-bind:class="[filterActive, activeClass ? 'open' : '']">
                  <!-- filter -->
                  <template slot="top-row" slot-scope="row">
                    <FilterTable :columns="row" :search="search" :filter="pages.filter"></FilterTable>
                  </template>
                  <!-- filter -->
                  <template slot="HEAD_actions" slot-scope="foo">
                    <b-form-checkbox class="uniform" @input="toggleSelected" v-model="allSelected"></b-form-checkbox>
                  </template>
                  <template slot="actions" slot-scope="row">
                    <b-form-checkbox :value="row.item.id" v-model="selected"></b-form-checkbox>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import { floatLabel } from '@/_floatLableClass.js';

  import { filters } from '@/_filterVar.js'
  const FilterTable = () => import('../partial/FilterTableV2')

  export default {
    name: 'feed-backs',
    components: {
      FilterTable,
      floatLabel,
    },
    data () {
      return {
        allSelected: false,
        selected: [],
        activeClass: false,
        isAction: false,
        contract_id: null,
        pages: {
          isCMS: '1',
          page : 1,
          limit : 25,
          totalPage : 1,
          filter : JSON.parse(JSON.stringify(filters['feed_backs'])),
        },
        columnActive : {
          fields: [
            {
              key: 'actions',
              label: '',
              thClass: 'checkbox-column text-center',
              tdClass: 'checkbox-column text-center',
              thStyle: "width:50px",
              isActive: 1
            },
            {
              key: 'id',
              label: '#',
              thStyle: "width:100px",
              isActive: 1,
              isFilter: true
            },
            {
              key: 'nature_of_feedack',
              label: 'Feedback Nature',
              isActive: 1,
              isFilter: true
            },
            {
              key: 'name_service',
              label: 'Service Category',
              isActive: 1,
              isFilter: true
            },
            {
              key: 'tag_name',
              label: 'Equipment',
              isActive: 1,
              isFilter: true
            },
            {
              key: 'fault_type',
              label: 'Fault Type',
              isActive: 1,
              isFilter: true
            },
            {
              key: 'building_path',
              label: 'Location',
              isActive: 1,
              isFilter: true
            },
            {
              key: 'requestor_name',
              label: 'Requestor name',
              isActive: 1,
              isFilter: true
            },
            {
              key: 'requestor_type',
              label: 'Requestor Type',
              isActive: 1,
              isFilter: true
            },
            {
              key: 'case_number',
              label: 'Case Number',
              isActive: 1,
              isFilter: true
            },
            {
              key: 'status',
              label: 'Status',
              isActive: 1,
              isFilter: true
            }
          ],
          show : [],
          hide : []
        },
        nameTable: 'tableFeedbacks',
        Items: {
          data: [
            {
              id: '0001',
              nature_of_feedack: 'General Enquires',
              name_service: 'ACMV',
              tag_name: null,
              fault_type: 'Water Leak',
              building_path: 'Marina Barrage >> DPS Building >> Maintenance Office >> Corridor',
              requestor_name: 'John Doe',
              requestor_type: 'Tenant',
              case_number: 'CA-ABC-1909-0001',
              status: 'Acknowledge'
            },
            {
              id: '0002',
              nature_of_feedack: 'Complaint',
              name_service: 'ACMV',
              tag_name: 'ACMV-AC002',
              fault_type: 'Others',
              building_path: 'Marina Barrage >> DPS Building >> Maintenance Office >> Corridor',
              requestor_name: 'Mary Jane',
              requestor_type: 'Public',
              case_number: null,
              status: 'Close'
            }
          ],
          total: 2
        },
        clientContract: [],
        users: [],
        hardcodeData:{
          contract:null,
          assign:null
        }
      }
    },
    watch: {
      "pages.limit": function (val) {
        if(this.pages.page === 1){
          this.reloadData();
        }{
          this.pages.page = 1;
        }
      },
      "pages.page": function (val) {
        this.reloadData();
      },
      selected: function(val) {
        if(this.Items.data.length > val.length) {
          this.allSelected = false
          return
        }
        if(val.length > 0 && this.Items.data.length == val.length) {
          this.allSelected = true
        }
      },
      ClientContractID: function(val, old) {
        if(val) {
          this.contract_id = val.id
          this.pages.filter.contract_id.value = val.id
        }
        else {
          this.contract_id = null
          this.pages.filter.contract_id.value = ''
        }
        this.allSelected = false
        this.selected = []
      }
    },
    computed: {
      ...mapGetters({
        UserLogin: "AuthController/user",
      })
    },
    mounted: function() {
      floatLabel()
    },
    updated: async function() {
      floatLabel()
    },
    async created(){
    },
    methods:{
      refresh() {
        this.allSelected = false
        this.selected = []
        this.pages.page = 1
        this.reloadData()
      },
      reloadData() {
      },
      search() {
        this.pages.page = 1
        this.reloadData()
      },
      redirectCreate() {
        return this.$router.push(`/v2/feedback/0`)
      },
      toggleSelected(val) {
        if (this.allSelected) {
          this.selected = [];
          for (let i in this.Items.data) {
            this.selected.push(this.Items.data[i].id)
          }
          return
        }
        if(!this.allSelected && this.Items.data.length == this.selected.length) {
          this.selected = []
        }
      },
      filterActive() {
        this.activeClass = !this.activeClass
      },
      editItem(item,index){
        this.$router.push(`/v2/meter/${item.id}`);
      },
      deleteData() {
        this.$refs['modal-Remove'].hide();
      },
      openModalRaiseACase() {
        this.getContract();
        this.$refs['modal-RaiseACase'].show();
      },
      getContract(filter = null, limit = 100) {
        this.$store.dispatch(`ContractController/getListClientContractsSearch`, [1, filter, limit])
        .then(response => {
          this.clientContract = response.data;
        })
      },
      async searchContract(search, loading) {
        loading(true);
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          this.getContract({ contract_name: search })
          loading(false);
        }, 300);
      },
    }
  }
</script>
